import { isEmpty } from "ramda";

const getArrayParamValue = arr => arr.map(item => item.value);

const getObjectParamValue = (nestedFields, value) =>
  isEmpty(nestedFields)
    ? value
    : {
        ...value,
        ...recursivePayload(nestedFields),
      };

export const recursivePayload = params =>
  Object.entries(params).reduce((acc, [paramKey, paramValue]) => {
    switch (paramValue.constructor) {
      case Array:
        return { ...acc, [paramKey]: getArrayParamValue(paramValue) };
      case Object: {
        const { label, value, ...nestedFields } = paramValue;
        const fieldValue = getObjectParamValue(nestedFields, value, label);
        return { ...acc, [paramKey]: fieldValue };
      }
      default:
        return { ...acc, [paramKey]: paramValue };
    }
  }, {});
